import React from 'react';
import ReactDOM from 'react-dom';
import { CoreApp } from './App';
import { i18n } from './utils/i18n';
import numeral from 'numeral';
import { getNumeralLocale } from './locales/numeralLocales';
import TagManager from 'react-gtm-module';
import locales from './locales';
import 'moment/locale/es';
import { gtmId, gtmAuth, gtmName, tenantGtmId } from 'config/envConfig';
import gtmEvents from 'utils/gtmEvents';
import { resolveTenant } from 'config/resolveTenant';

const userLanguage = localStorage.getItem('locale') || 'es';

i18n.initialize(userLanguage);
i18n.addResources('es', 'translations', locales.es)
i18n.addResources('en', 'translations', locales.en)

numeral.locale('es');
numeral.register('locale', 'es', getNumeralLocale('es'));

// Resolve tenant from hostname, then mount the app.
// This ensures tenantId/tenantName are set before any component reads them.
resolveTenant().then(() => {
  try {
    if (tenantGtmId && tenantGtmId.includes("GTM")) {
      TagManager.initialize({gtmId: tenantGtmId});
    }

    if (gtmId) {
      TagManager.initialize({
        gtmId: gtmId,
        auth: gtmAuth,
        preview: gtmName,
        dataLayerName: 'geoDatalayer'
      });

      gtmEvents.initializeEvent();
    }
  } catch (err) {
    console.error('[init] GTM initialization failed:', err);
  }

  ReactDOM.render(
    <React.StrictMode>
        <CoreApp />
    </React.StrictMode>,
    document.getElementById('root')
  );
}).catch((err) => {
  console.error('[init] Fatal error in app initialization:', err);
});
